import * as React from 'react'
import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import CloseSvgIcon from '@svg/CloseSvglcon'
import { setUserObjData, getUserObjData } from '@common/services/cookies.service'
import { useLanguageContext } from '@/contexts/LanguageContext'

const cookiesStyle = {
  p: 2,
  width: '100%',
  position: 'fixed',
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  zIndex: 10,
  background: (theme: any) => theme.palette.primary.light
}

const CookieAlert = () => {
  const [cookieLows, setCookieLows] = React.useState(true)
  const { translations } = useLanguageContext()

  React.useEffect(() => {
    setCookieLows(!!getUserObjData('cookieAlert'))
  }, [])

  const setCookieFalse = () => {
    setCookieLows(true)
    setUserObjData(true, 'cookieAlert')
  }

  return !cookieLows ? (
    <Box sx={cookiesStyle}>
      <Typography color='text.primary' fontWeight='400'>
        {translations.COOCKIE_TEXT}
        <Link
          href={translations.COOCKIE_POLICY_LINK || 'https://fielddrive.com/cookie-policy/'}
          target='_blank'
          sx={{ textDecoration: 'none' }}
        >
          <Button variant='contained' size='small' sx={{ ml: 1 }}>
            {translations.COOCKIE_POLICY}
          </Button>
        </Link>
      </Typography>
      <IconButton onClick={setCookieFalse}>
        <CloseSvgIcon />
      </IconButton>
    </Box>
  ) : (
    ''
  )
}
export default CookieAlert
